 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		83: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","4":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"customCollectionPage","18":"fc-components-main-components","19":"feed","20":"loginPage","21":"logoutPage","22":"magazineTagPage","23":"magazine_page","24":"myAccountPage","25":"newsletters_page_marketo","26":"notFoundPage","27":"offerPage","28":"playlistIndexPage","29":"playlistPage","30":"podcastPage","31":"post_page","32":"registerPage","33":"resetPasswordPage","34":"sitemapIndex","35":"sitemapPost","36":"stories","37":"subscribePage","38":"tagPage","39":"videoIndex","40":"videoPage","41":"views-containers-layouts-blank_layout-blank_layout","42":"views-containers-layouts-web_layout-web_layout","78":"MarketoNewsletterForm","79":"MicCarousel","80":"MicIcon","81":"MicMobileIconCarousel","82":"Success-SubmissionSuccess","84":"applications-most-innovative-companies","85":"brands_that_matter_2021","86":"brands_that_matter_page","87":"categoryLink","88":"components-BackgroundHighlight-BackgroundHighlight","89":"components-MultiTabList-MultiTabList","90":"components-QuickCarousel-QuickCarousel","91":"components-StickyBar-StickyBar","92":"components-all_feed-all_feed","93":"components-categories","94":"components-config-config","95":"components-editor_highlights-editor_highlights","96":"components-finite_scroll","97":"components-footer-footer","98":"components-franchise_intro-franchise_intro","99":"components-ibd_category-ibd_category","100":"components-image-image","101":"components-magazine_archive-magazine_archive","102":"components-masthead-masthead","103":"components-mcp_section-mcp_section","104":"components-mic_mobile_menu-mic_mobile_menu","105":"components-more-stories-component-more-stories-component","106":"components-newsletters-recaptcha","107":"components-notice","108":"components-piano-pianoBottomBanner","109":"components-podcast_tile-podcast_tile","110":"components-podcast_tile-podcast_tile_featured","111":"components-post-content-insert","112":"components-ranked","113":"components-recirc-recirc","114":"components-related_posts-related_posts","115":"components-related_slider-related_slider","116":"components-sectors_list-sectors_list","117":"components-social-social","118":"components-top_50-top_50","119":"components-top_50_shuffle-top_50_shuffle","120":"components-video_megatron-video_megatron","121":"components-video_module-utils-video_module_ads","122":"components-video_module-video_module","123":"containers-pages-list_landers-bwi-2020","124":"containers-pages-list_landers-ibd-2020","125":"containers-pages-list_landers-mic-2021","126":"content-innovation_festival_banner","127":"content-sponsor_bar","128":"fc-components-main-components-StickyBar-StickyBar","129":"fc-components-main-containers","130":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","131":"fc-components-main-containers-IbdLayout-IbdLayout","132":"fc-components-main-containers-WciLayout-WciLayout","133":"fc-components-main-utils-ConditionalWrapper","134":"franchises-BtmApplyPage","135":"franchises-BwiApplyPage","136":"franchises-IbdApplyPage","137":"franchises-MicApplyPage","138":"franchises-NbttApplyPage","139":"franchises-WciApplyPage","140":"innovation_by_design_future_page","141":"innovation_by_design_page_franchise","142":"innovation_by_design_page_franchise_2023","143":"layouts","144":"layouts-mcp","145":"nav_main_menu-nav_main_menu","146":"package_article_list_entry","147":"packages-nav-package_sticky_nav","148":"post-content-sidebar","149":"topics"}[chunkId]||chunkId) + "." + {"1":"7c2130ad48a099eacc30","2":"76b2ddc5ad9f0705c1e6","3":"00dbdf0c27699c3d9f7d","4":"b8ab16bfbc8d98c16e08","5":"b208e6ef052583f9723b","6":"98589e43f378bc881bae","7":"8ded755a0de5037f08c8","8":"f4d66c8515f8193cbf8e","9":"01f23cb6f3b67cfb58db","10":"811ea77f27fa966e2067","11":"3ae2a42803f50bb1e732","12":"08e48038a9ff2041b8dc","13":"bb40d65fe0ed386f310a","14":"33c91d5ed96a5085acf9","15":"9e4c5dc3617a3fb3eec7","16":"1ef94d355375f5751bc9","17":"9f2a7a5efd2f4f6b1b96","18":"922ad2353099a3c6eaf4","19":"beb933377e83cc6963da","20":"15fe2d1e8c10d7f43410","21":"514c76efeb62523ec733","22":"c15761fcd4a5252ce53d","23":"2d9926a1e356aecd60bb","24":"a031198ef9df2703aaca","25":"270b3230b27dd608d814","26":"4a8d9562a3e9eeb91f84","27":"5136434e41bac1eed3f7","28":"fe946faabc8e5320c51a","29":"e5f774e2d98d7437fb89","30":"6fedb3d87b03eb8cb5d5","31":"a7f6696b464578974e9f","32":"c4ac9434d189caf44e69","33":"b5e2f3da2aa46e7a833a","34":"952a431abcc37211d6f7","35":"e162dd3eec39898ddac1","36":"86b4d66d8059ccfcc8e6","37":"885d095c67fce6345cc4","38":"e22b290ee49d43b4f077","39":"4a77a4fd1761774b9ef1","40":"a1e4f56982e5762451de","41":"70b9c17bacdb4488a09b","42":"08971921213546354eaf","43":"f880d762d1b40442fbb4","44":"ecfda67f91d2dee7abb7","45":"3218bf3789c9f2afec64","46":"6a32cd64695b13cd68f1","47":"489b12395d0ec02b88a1","48":"62c3b42b704ceaef5563","49":"bc50ff0b7420fe61611b","50":"4970c333925e2df31fa9","51":"3999a2f251e67fa820b5","52":"e31ff93cab9070d6fbb9","53":"8e3ba12a72f8d0e9e430","54":"edc89f679abcf20c2159","55":"9e53676e1dc73341e295","56":"23f15c55a2fd45bece9b","57":"bc905a74f943d992bb53","58":"b5209dea81c2c20aeaac","59":"4ea361c8268307c9db4c","60":"68d68e2262a63014d373","61":"905b3ee9cf024a35fa6b","62":"3f65d5426d13b16be988","63":"0fcfa225c586014c8515","64":"083939ce450cecd8832b","65":"8405260da97a0fea48e3","66":"36ed4bf89f643d8b4462","67":"8d57947d38512975d03b","68":"4fc42433b17a69186f47","69":"4674c7718ca36dfc1fb8","70":"349166dcba239b5d4fa7","71":"26ff4cdb79051b086ea9","72":"3cf3fcb6749d43149a3e","73":"c9231aa1031bf662f817","74":"e80ab3b29c68588e60a7","75":"d202a0f67e8084f05b92","76":"36f8ea14aeb6a00814bd","77":"f74cc5849a651bdc3974","78":"9bdb92902564528435fd","79":"61724d5fca73c1d7a418","80":"7ec2f9799a8e8b696c41","81":"dca38fd342dda3187331","82":"fe002496d3d328dcc7a6","84":"6b23ba10a1307d34b132","85":"b5b561fe055e464860a3","86":"f0d633818c24ff796ac5","87":"68fc474ee957e530d567","88":"9d2527c61f3bcb4a90e4","89":"4bc21265a9aea745f968","90":"1b71a60a7a3072ca4fb6","91":"b269becc19a7c705a027","92":"2fe00640b8d4fca4e631","93":"3e3a4456cd3cc93fa567","94":"cce3e5c0be37bf2a97f3","95":"cea215d89328c7b67cce","96":"fac067399c9bbe7cf307","97":"5dd62e41b39514167398","98":"fa3766d69ab88cd12854","99":"773b29ee09f6b8b3a460","100":"c2e2116be2d940ed9b5b","101":"d92f52dd4f6bc34719d6","102":"6e54d411c8739cad070a","103":"7c48d4da4c7da6662029","104":"d44a8eeb5bbe1269c526","105":"ccf1b28f6554e30640bf","106":"70475d23b42c9b5d2008","107":"31f4ccdd6efab825c129","108":"211455786a34bd039896","109":"2e9eedc802093f6b5091","110":"b28492e3ef0bb21b9a44","111":"e2a23b0c98633104584a","112":"9cf9018e470b4dfe4039","113":"0c3a52e135e3af329288","114":"2ea3d8d62646d56b7e83","115":"ce58a949c49b74fa6c0b","116":"02d4a40ff74f40270406","117":"a7d24431013c643c18bd","118":"63e4b89f662dfb8f40f4","119":"8106c289b816573fd068","120":"6e1aeee8d227c5af569a","121":"5bcca77833032cff9c74","122":"fb717311ca40bef94f9f","123":"05ec9cfcdab5d6744444","124":"b4dbba1268430626482c","125":"19e6103869aab0f33eca","126":"19aa2d160b7b4d573f3a","127":"9881c0ef2d109aec63b8","128":"20824d6de6bdbb7d5056","129":"b85d16057ff9d793f16e","130":"607d421a16277c4b88e4","131":"042f0d8e686e4de0fe20","132":"260c435f23f7855f0dbc","133":"b1f336d0e5307588696c","134":"2f25b3b96a201d076614","135":"3e24dbee5428ab8db88f","136":"c2f66384c317d4d192f9","137":"15da18e66849638533b2","138":"d9502bced2871e533ddb","139":"5f14b720cbbf082fa359","140":"ec49ae0c3b548904352d","141":"2b632537d3a30ecc9eb0","142":"cbccb499255441919b01","143":"bc87fa3ec2715b97dd2b","144":"2b23847874f6c6a48533","145":"744e8fc463c31b591220","146":"1a3e9b42bf7c1f534bab","147":"3c39b2e50aa0fd834f8e","148":"f7a0099c10cb398bc063","149":"bbb513f1d12ea4173aff"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([860,150,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
